// @flow

import axios from 'axios';

import { API_BASE } from './settings';


export default class ContactService {

    send(data) {
        return new Promise((resolve, reject) => {

            axios.post(`${API_BASE}/api/contacts/`, data)
                .then((res) => {
                    resolve(true);

                })
                .catch((error) => {
                    reject(error.response);

                });

        });
    }

}



// WEBPACK FOOTER //
// ./src/services/contact.js